<app-ace-file-upload
  [buttonText]="{messageKey: 'Select image'}"
  [clearButtonText]="{messageKey: 'Clear image'}"
  [dropText]="{messageKey: 'Or drop image here'}"
  accept="image/*"
  [maxFileSize]="maxFileSize"
  [filesUploaded]="!!imageFileBase64"
  (filesChanged)="fileInputChangeListener($event)"/>

@if (cropperReady) {
  <h5 class="my-2">{{ 'Crop Image' | messageTranslate }}</h5>
}
<div style="font-size: 0;">
  <!-- Use inline-block as this is the only standard CSS way (until 'fit-content' is standardised) of making the div
  have the width of it's contents. As we would like to left align the image cropper, and it centres itself, need to
  ensure the div is only as wide as the content, so that centering inside the cropper has no effect -->
  <div [class]="cropperReady ? 'd-inline-block' : 'd-none'">
    @let allowSmallerThanMinimum = photoWarningMessages;
    <image-cropper
      output="base64"
      [cropperMinWidth]="allowSmallerThanMinimum ? null : cropperMinDimensions?.width ?? null"
      [cropperMinHeight]="allowSmallerThanMinimum ? null : cropperMinDimensions?.height ?? null"
      [imageBase64]="imageFileBase64 ? imageFileBase64 : ''"
      [maintainAspectRatio]="maintainAspectRatio"
      [aspectRatio]="aspectRatio"
      [resizeToWidth]="resizeToWidth"
      [format]="format"
      (imageCropped)="imageCroppedBase64($event)"
      (imageLoaded)="imageLoaded()"
      (loadImageFailed)="imageLoadFailed()"/>
  </div>
</div>
@for (message of photoWarningMessages; track $index;) {
  <div class="small text-secondary">
    <fa-icon icon="triangle-exclamation" class="text-warning" [fixedWidth]="true"/>
    {{message | messageTranslate}}
  </div>
}

@if (cropperReady) {
  <h5 class="my-2">{{ 'Preview' | messageTranslate }}</h5>
}
@if (cropperReady && croppedImg) {
  <span class="result rounded">
    <img [src]="croppedImg" [style.width.px]="previewDisplayDimensions?.width" [style.height.px]="previewDisplayDimensions?.height">
  </span>
}
